const docsToShipmentRecords = require('./tools/docs-to-shipment-records')

async function getShipmentByNumber (state, params = {}) {
  // This is a new function that gets shipments by their shipment numbers.
  // For shipments with the 12 alphanumeric chars, shipment numbers are guaranteed to be unique.
  const { shipmentNumber } = params

  if (!shipmentNumber || shipmentNumber === '') {
    const err = new Error('ShipmentNumber parameter is required')
    err.status = 400
    throw err
  }

  try {
    const docs = await state.dal.shipment.getShipmentByNumber(state, shipmentNumber)

    if (!docs || docs.length === 0) {
      return []
    }

    const transformedDocs = docsToShipmentRecords(null, docs, {})

    if (transformedDocs.length > 1) {
      const err = new Error(`Multiple shipments found with shipment number: ${shipmentNumber}`)
      throw err
    }

    return transformedDocs[0]
  } catch (e) {
    const err = new Error(`Error getting shipment by shipment number: ${e.message}`)
    err.status = 500
    throw err
  }
}

module.exports = getShipmentByNumber
